<svelte:options customElement="clever-search-chat-embedded" />

<script lang="ts">
  /** stores */
  import { ConfigStore } from './lib/store/config';
  /** others */
  import { fly } from 'svelte/transition';
  import { WidgetType } from './lib/enums/widget-type.enum';
  import { shadowDomUpdates } from './lib/helpers/shadowdom-updates';
  import { onMount } from 'svelte';

  $ConfigStore = {
    ...$ConfigStore,
    widgetType: WidgetType.ce,
  };

  onMount(() => {
    shadowDomUpdates('clever-search-chat-embedded', true);
  });
</script>

{#if !!$ConfigStore.apiBaseUrl}
  <div
    class="cs-wrapper"
    transition:fly|global={{
      y: 50,
      duration: 1000,
    }}
  >
    <clever-search-chat />
  </div>
{/if}
